export type DyeColorId =
  | 'white' | 'orange' | 'magenta' | 'light_blue' | 'yellow' | 'lime'
  | 'pink' | 'gray' | 'light_gray' | 'cyan' | 'purple' | 'blue'
  | 'brown' | 'green' | 'red' | 'black';

export type BannerPatternId =
  | 'minecraft:base'
  | 'minecraft:stripe_top' | 'minecraft:stripe_bottom'
  | 'minecraft:stripe_left' | 'minecraft:stripe_right'
  | 'minecraft:stripe_center' | 'minecraft:stripe_middle'
  | 'minecraft:stripe_downright' | 'minecraft:stripe_downleft'
  | 'minecraft:small_stripes'
  | 'minecraft:cross' | 'minecraft:straight_cross'
  | 'minecraft:diagonal_left' | 'minecraft:diagonal_right'
  | 'minecraft:diagonal_up_left' | 'minecraft:diagonal_up_right'
  | 'minecraft:half_vertical' | 'minecraft:half_vertical_right'
  | 'minecraft:half_horizontal' | 'minecraft:half_horizontal_bottom'
  | 'minecraft:square_top_left' | 'minecraft:square_top_right'
  | 'minecraft:square_bottom_left' | 'minecraft:square_bottom_right'
  | 'minecraft:triangle_top' | 'minecraft:triangle_bottom'
  | 'minecraft:triangles_top' | 'minecraft:triangles_bottom'
  | 'minecraft:circle' | 'minecraft:rhombus'
  | 'minecraft:border' | 'minecraft:curly_border'
  | 'minecraft:gradient' | 'minecraft:gradient_up'
  | 'minecraft:bricks'
  | 'minecraft:creeper' | 'minecraft:skull'
  | 'minecraft:flower' | 'minecraft:mojang'
  | 'minecraft:globe' | 'minecraft:piglin'
  | 'minecraft:flow' | 'minecraft:guster';

export type PreviewMode = 'banner' | 'shield';

export type BannerTab = 'base' | 'patterns' | 'name' | 'enchant' | 'output';

export interface BannerLayer {
  id: string;
  pattern: BannerPatternId;
  color: DyeColorId;
  enabled: boolean;
}

export interface BannerEnchantment {
  id: string;    // e.g. "minecraft:unbreaking"
  level: number;
}

export interface BannerState {
  baseColor: DyeColorId;
  layers: BannerLayer[];
  previewMode: PreviewMode;
  allowExtendedLayers: boolean;
  enchantments: BannerEnchantment[];
  customName: string;
  lore: string[];
  noItalic: boolean;
  glintOverride: boolean | null;
}

export function createLayer(pattern: BannerPatternId, color: DyeColorId, enabled = true): BannerLayer {
  return {
    id: crypto.randomUUID(),
    pattern,
    color,
    enabled,
  };
}

export function createDefaultBannerState(): BannerState {
  return {
    baseColor: 'white',
    layers: [],
    previewMode: 'banner',
    allowExtendedLayers: false,
    enchantments: [],
    customName: '',
    lore: [],
    noItalic: true,
    glintOverride: null,
  };
}
